import Main from './Main.vue'

const DEFAULT_OPTIONS = {
  y: 'bottom',
  x: null,
  mode: '',
  timeout: 2000,
  showClose: false,
  rounded: 'pill'
}

const Plugin = function (Vue, options = {}) {
  const property = options.property || '$snackbar'
  delete options.property
  const vuetify = options.vuetify
  delete options.vuetify
  if (!vuetify) {
    console.warn('Plugins dialog needs vuetify instance. Use Vue.use(Snackbar, { vuetify })')
  }
  const Snackbar = Vue.extend(Object.assign({
    vuetify
  }, Main))

  const show = (options) => {
    const container = document.querySelector('#app > .v-application--wrap') || document.body
    return new Promise(resolve => {
      const cmp = new Snackbar(Object.assign({}, {
        data: Object.assign({}, options),
        destroyed: () => {
          container.removeChild(cmp.$el)
          resolve(cmp.value)
        }
      }))
      container.appendChild(cmp.$mount().$el)
    })
  }

  Vue.prototype[property] = (message, options = {}) => {
    return show(Object.assign(DEFAULT_OPTIONS, options, {
      message,
      visible: true
    }))
  }
}

export default Plugin
